import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Route, Switch} from 'react-router-dom'
import { bindActionCreators } from 'redux'

import {actions as authActions} from '../../redux/modules/Auth'//
import ResellerVehiclesTableContainer from './ResellerVehiclesTableContainer'//
import ResellerVehiclesWaitingListTableContainer from './ResellerVehiclesWaitingListTableContainer'//


const mapStateToProps = (state) => {
  return {
    state: state.auth
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authActions: bindActionCreators(authActions, dispatch)
  }
}

class ResellerVehiclesContainer extends Component {
  constructor (props) {
    super(props)    
  }

  render () {
    return (
      <Switch>        
        <Route path="/reseller/vehicles/waiting-list" component={(props) => <ResellerVehiclesWaitingListTableContainer {...props} />} />        
        <Route path="/reseller/vehicles"              component={(props) => <ResellerVehiclesTableContainer {...props} />} />
      </Switch>)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResellerVehiclesContainer)
